export const typeOfPAF = {
  MALE: "male",
  WOMANOFNCP: "womanOfNCP",
  WOMANOFCP: "womanOfCP",
  WOMANOFCPRENEW2: "womanOfCPRenew2",
};
